module.exports = __webpack_public_path__ + "static/media/03d.e0e1951b.svg";